<template>
  <div>
    <v-overlay :value="loadingScreen">
      <v-progress-circular
          :size="70"
          :width="7"
          indeterminate
      ></v-progress-circular>
    </v-overlay>
    <component :is="tabs[usersRole]" />
  </div>
</template>

<script>
import TranscriptQueueMTA from "@/views/TranscriptQueue/TranscriptQueueMTA.vue"
import TranscriptQueueAOR from "@/views/TranscriptQueue/TranscriptQueueAOR.vue"
import AuthService from "@/services/auth.service";
import {mapGetters} from "vuex";
export default {
  name: 'TranscriptQueue',
  components: {TranscriptQueueMTA, TranscriptQueueAOR},
  data: () => ({
    tabs: [],
    usersRole: null,
    loadingScreen: true,
  }),
  methods: {
    getUser() {
      return AuthService.getCurrentUser(this.currentUser.current_user_id).then((res) => {
        this.usersRole = res.data.role_id;
      }).finally(() => this.loadingScreen = false)
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/getCurrentUser",
    }),
  },
  async created() {
    this.tabs[1] = 'TranscriptQueueMTA'
    this.tabs[4] = 'TranscriptQueueAOR'
    this.tabs[7] = 'TranscriptQueueAOR'
    this.tabs[9] = 'TranscriptQueueMTA'
    this.tabs[13] = 'TranscriptQueueMTA'
    await this.getUser()
  }

}
</script>